export enum SourcingPage {
  Search = "search",
  Shortlist = "shortlist",
  Seen = "seen",
}
